import typeList from './type-list'

export default class FormItemMultiple {
  constructor (elem) {
    this.elem = elem
    this.parts = elem.querySelectorAll(':where([type="checkbox"], [type="radio"]')
    this.types = this.getTypes(elem)

    this.createMessageElem()
    this.messageElem = elem.parentNode.querySelector('.form-error')
  }

  createMessageElem () {
    const newElem = document.createElement('div')
    newElem.classList.add('form-error')
    this.elem.parentNode.insertBefore(newElem, this.elem.nextSibling)
  }

  // 要素がどのタイプに属するか
  getTypes (item) {
    const types = []
    const typeKeys = Object.keys(typeList)

    typeKeys.forEach(type => {
      if (item.classList.contains('input-' + type)) {
        types.unshift(type)
      }
    })
    return types
  }

  validate () {
    this.messages = []
    this.types.forEach(type => {
      this.hasChecked()
      const validation = typeList[type].validate(this.value)

      if (!validation) {
        const priority = typeList[type].priority
        this.messages[priority] = typeList[type].message
      }
    })

    this.showMessage()
  }

  // ひとつでも選択された項目があるか
  hasChecked () {
    let checkedNum = 0
    this.parts.forEach(item => {
      if (item.checked) checkedNum += 1
    })

    this.value = checkedNum > 0
  }

  showMessage () {
    if (this.messages.length > 0) {
      this.messageElem.innerText = this.messages[0]
    } else {
      this.messageElem.innerText = ''
    }
  }

  errorNum () {
    return this.messages.length
  }
}
